<template>
  <div class="home page-container" >
    <!--category 2 products-->
    <div class="banner">
      <swiper :options="bannerSwiper">
        <swiper-slide v-for="(item,index) in filterBillboard(this.$store.state.billboard.billboardImages, $i18n.locale)" data-index="index" :key="index">
          <div v-if="item.URL"><a :href="item.URL"><img class='swiImg' :src='item.Image' /></a></div>
          <div v-else><img class='swiImg' :src='item.Image' /></div>
        </swiper-slide>
      </swiper>
      <div class="banner-button-prev"></div>
      <div class="banner-button-next"></div>
    </div>
    <div class="b2b-category2">
      <div class="page-width">
        <div class="top3">
          <div
            class="card"
            v-for="(item,index) in customB2BCategories.slice(0, 3)"
            v-model="local=item.Products=='local'"
            data-index="index"
            :key="index"
            @click="goToCategory2(item)"
          >
            <div class="logo">
              <img v-if="item.IsAFGChoice" class="afg-tag" src="../../assets/img/afg_choice_tag.png" alt="">
              <img class="logo-image" :src="item.Image" alt="">
            </div>
            <div>
              <img v-if="item.Image2" class="image" :src="item.Image2" alt="">
              <img v-else class="image" src="../../assets/img/coming.png" alt="">
            </div>
          </div>
        </div>
        <div class="grid">
          <div
            class="card"
            v-for="(item,index) in customB2BCategories.slice(3)"
            v-model="local=item.Products=='local'"
            data-index="index"
            :key="index"
            @click="goToCategory2(item)"
          >
            <div class="logo-image">
              <img :src="item.Image" alt="">
            </div>
            <div class="image-group">
              <img v-if="item.IsAFGChoice" class="afg-tag" src="../../assets/img/afg_choice_tag.png" alt="">
              <img v-if="item.Image2" class="image" :src="item.Image2" alt="">
              <img v-else class="image" src="../../assets/img/coming.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="client">
        <h3 :style="'color: white;'">AS FEATURED ON</h3>
        <div class="client-list">
          <img src='../../assets/img/client1.png' alt="" />

          <div class="hoverImg">
            <img class="logo" src='../../assets/img/client2.png' alt=""/>
            <div class="hoverComment">
              <img src="../../assets/img/client2_comment.png" alt="">
            </div>
          </div>
          <img src='../../assets/img/client3.png' alt="" />
          <img src='../../assets/img/client4.png' alt="" />
          <div class="hoverImg">
            <img class="logo" src='../../assets/img/client5.png' alt=""/>
            <div class="hoverComment_1">
              <img src="../../assets/img/client5_comment.png" alt="">
            </div>
          </div>
          <img src='../../assets/img/client6.png' alt="" />
        </div>
      </div>
    </div>
    <!-- end category 2 products-->
    <!-- customer -->
    <div class="Custom">
      <div class="index-section">
        <div class="page-width text-center">
          <h2><span :style="'color: black;'">Customers</span> ❤️ Elegant Granite</h2>
          <h4 :style="'font-weight: 500;'">Customers love us as much as we love them</h4>
          <div class="home-recipe">
            <ul>
              <li>
                <div class="recipe-image">
                  <img src="../../assets/img/user1.png" alt="">
                </div>
                <div class="recipe-text">
                  <p class="text">
                    This was my first ordering and I am extremely pleased.
                    Great selection with affordable prices.
                    Flat rate shipping was also an added bonus.
                    My order was processes quickly with great communication.
                    I will definitely use then often in the future.
                  </p>
                  <p class="mobile-hide"><strong>Melissa</strong></p>
                </div>
              </li>
              <li>
                <div class="recipe-image">
                  <img src="../../assets/img/user2.png" alt="">
                </div>
                <div class="recipe-text">
                  <p class="text">
                    This is and awesome online source of authentic.
                    Japanese foods of all sorts--sembe, yokan, gourmet Japanese rice, nori,
                    omochi and multitudes of different authentic cnadies and condiments.
                    Besides, ant size orderexceeeding $30 ships for only $5!!
                  </p>
                  <p class="mobile-hide"><strong>yokanlover</strong></p>
                </div>
              </li>
              <li>
                <div class="recipe-image">
                  <img src="../../assets/img/user3.png" alt="">
                </div>
                <div class="recipe-text">
                  <p class="text">
                    Great customer service!! One of the items I ordered was out of stock
                    and they gave me a refund right away and also some complentary items.
                    I am very pleased with the items I recieved and I will definitely order again.
                  </p>
                  <p class="mobile-hide"><strong>Destie</strong></p>
                </div>
              </li>
              <li>
                <div class="recipe-image">
                  <img src="../../assets/img/user4.png" alt="">
                </div>
                <div class="recipe-text">
                  <p class="text">
                    Wheneve I need a Japanese snack fix. I order from them!!
                    They are so great and have lots of items to choose from.
                  </p>
                  <p class="mobile-hide"><strong>Brittany</strong></p>
                </div>
              </li>
            </ul>
          </div>
          <button><span>{{ $t('readMore') }}</span></button>
        </div>
      </div>
    </div>
    <!-- end recipes -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import axios from 'axios';
import { isUserAuthenticated, flyToElement } from '../../store/modules/cart';
import productCard from '../productCard';
import { CUSTOMER_INFORMATION_URL } from '../../api/url';

export default {
  name: "b2bHome",
  components: {
    productCard,
  },
  data() {
    return {
        bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
    }
  },
  methods:{
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    goToCategory2(cat2) {
      this.$router.push(`/category2/${cat2.Name.toLowerCase()}`)
    },
    filterBillboard(billboard, language) {
      let filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      filterBillboard = filterBillboard.filter(image => {
        return (image.CustomerType === 'b2b' || image.CustomerType === 'all');
      });
      return filterBillboard;
    },
  },
  computed: mapState ({
    customB2BCategories: state => state.products.customB2BCategories,
    cartProductsList: state => state.cart.cartProductsList, // not used, in mathod still geting form $store
    necessaryCartItems: state => state.cart.necessaryCartItems,
    business: state => state.auth.userDetails.IsBusiness,
  }),
  mounted() {
    this.$store.dispatch('products/fetchB2BCustomCategories');
  },
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/home.less";
</style>



// WEBPACK FOOTER //
// src/view/Home/b2bHome.vue